$(function () {
    const links = $('.url-params');

    // not supported for IE
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.delete('slug');
    const newSearch = searchParams.toString();
    const newSearchParams = newSearch ? `?${newSearch}` : '';

    for (const link of links) {
        const jLink = $(link);
        jLink.attr('href', jLink.attr('href') + newSearchParams);
    }
});
